/**
 * Created by rossphelan on 24/09/15.
 */
angular.module('qkr').controller('ReportSuspendDatePickerController', ($scope, $rootScope, $uibModalInstance, utils,
                                                                       gettextCatalog) => {
    const weekStartDay = 1;
    const validate = function() {
        $scope.errors = {};
        let errors = null;
        let valid = true;

        if (utils.hasNoValue($scope.suspendDate)) {
            errors = {};
            errors.suspendDate = gettextCatalog.getString('A resume date is required');
            valid = false;
        }

        return valid;
    };

    $scope.cancel = function() {
        $uibModalInstance.close('cancel');
    };

    $scope.save = function() {
        if (!validate()) {
            return;
        }

        $uibModalInstance.close($scope.suspendDate);
    };

    $scope.dateOptions = {
        startingDay: $rootScope.merchantInfo? $rootScope.merchantInfo.contactDetails.country.weekStartingDay : weekStartDay,
        showWeeks: false
    };
});



// WEBPACK FOOTER //
// ./src/controllers/modal/reportSuspendDatepicker.controller.js